import React, { useState } from "react";
import { logoutUser } from "../firebase";
import { User, LogOut, Settings, Download, Upload, Sparkles } from "lucide-react";

const UserProfile = ({ user, onLogout, onExportData, onImportData, isDemoMode, onExitDemo }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logoutUser();
      onLogout();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const handleExport = () => {
    const dataStr = JSON.stringify(
      localStorage.getItem("jobTrackerJobs"),
      null,
      2,
    );
    const dataBlob = new Blob([dataStr], { type: "application/json" });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `job-tracker-backup-${new Date().toISOString().split("T")[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jobs = JSON.parse(e.target.result);
          onImportData(jobs);
        } catch (error) {
          alert(
            "Invalid backup file. Please select a valid Job Tracker backup.",
          );
        }
      };
      reader.readAsText(file);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="flex items-center gap-3 px-4 py-2 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
      >
        <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
          {user && user.photoURL ? (
            <img
              src={user.photoURL}
              alt={user.displayName}
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <User className="w-4 h-4 text-white" />
          )}
        </div>
        <span className="text-sm font-medium text-gray-700">
          {user && (user.displayName || user.email)}
        </span>
      </button>

      {showMenu && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-20">
            <div className="p-4 border-b border-gray-200">
              <p className="font-medium text-gray-900">
                {user && (user.displayName || "User")}
              </p>
              <p className="text-sm text-gray-500">{user && user.email}</p>
            </div>

            {isDemoMode ? (
              <>
                <div className="px-4 py-3 bg-amber-50 border-b border-gray-200">
                  <div className="flex items-center gap-2 mb-1">
                    <Sparkles className="w-3.5 h-3.5 text-amber-600" />
                    <span className="text-xs font-medium text-amber-700">
                      Demo Mode
                    </span>
                  </div>
                  <p className="text-xs text-amber-600">
                    Sign up to save your data
                  </p>
                </div>
                <div className="py-2">
                  <button
                    onClick={() => {
                      setShowMenu(false);
                      onExitDemo();
                    }}
                    className="w-full px-4 py-2 text-left hover:bg-red-50 flex items-center gap-3 text-red-600"
                  >
                    <LogOut className="w-4 h-4" />
                    <span className="text-sm">Exit Demo</span>
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="py-2">
                  <button
                    onClick={handleExport}
                    className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-3"
                  >
                    <Download className="w-4 h-4 text-gray-500" />
                    <span className="text-sm text-gray-700">Export Data</span>
                  </button>

                  <label className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-3 cursor-pointer">
                    <Upload className="w-4 h-4 text-gray-500" />
                    <span className="text-sm text-gray-700">Import Data</span>
                    <input
                      type="file"
                      accept=".json"
                      onChange={handleImport}
                      className="hidden"
                    />
                  </label>

                  <button className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-3">
                    <Settings className="w-4 h-4 text-gray-500" />
                    <span className="text-sm text-gray-700">Settings</span>
                  </button>
                </div>

                <div className="py-2 border-t border-gray-200">
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left hover:bg-red-50 flex items-center gap-3 text-red-600"
                  >
                    <LogOut className="w-4 h-4" />
                    <span className="text-sm">Sign Out</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfile;
